/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_General_Project_StateInputs */



/**
* | output |
* | --- |
* | "Project State" |
*
* @param {Options_General_Project_StateInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_general_project_state = /** @type {((inputs?: Options_General_Project_StateInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_General_Project_StateInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("État du projet")
	if (locale === "de") return /** @type {LocalizedString} */ ("Projektstatus")
	if (locale === "it") return /** @type {LocalizedString} */ ("Stato del progetto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Проект «Государство»")
	if (locale === "es") return /** @type {LocalizedString} */ ("Estado del proyecto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("项目状态")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロジェクトの状態")
	if (locale === "hi") return /** @type {LocalizedString} */ ("परियोजना राज्य")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Projeto Estado")
	return /** @type {LocalizedString} */ ("Project State")
});